export const iconsSrcMapping = {
  promotionExpired: { name: "BlackFridayExpired.svg" },
  productNotFound: { name: "ProductNotFound.svg" },
  pageNotFound: { name: "PageNotFound.svg" }
}
